import React, { useState, useEffect } from "react";
import firebase from "@firebase/app";
import "@firebase/auth";
import { toStringFormat } from "../services/Utils";
import CashplusOperationsTable from "../components/Operations/CashplusOperationsTable"
import { getFailedCashplusOperations,DownloadCashplusOperationsXlsx } from "../services/OperationsService";
import DatePicker, { registerLocale } from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import fr from "date-fns/locale/fr";
import {
  Table,
  Button,
  Card,
  Container,
  Row,
  Col,
  Alert
} from "react-bootstrap";
import Loader from "react-loader-spinner";
import "react-loader-spinner/dist/loader/css/react-spinner-loader.css";
import { Input } from "reactstrap";

var summary;
var status;

registerLocale("fr", fr);

function CashplusOperations() {
  const [data, setData] = useState(null);

  const [loading, setLoading] = useState(true);
  const [SummariesLoading, setSummariesLoading] = useState(false);
  const [filters, setFilters] = useState({
    fmcg: null,
    startDate: new Date(new Date().setDate(new Date().getDate() - 15)),
    endDate: new Date(),
  });

  function onChange(user) {
    if (!user) {
      window.location.href = "/";
    }
    setLoading(false);
  }

  React.useEffect(() => {
    const unsubscribe = firebase.auth().onAuthStateChanged(onChange);
    return () => unsubscribe();
  }, []);

  const reload = async () => {
    if (!loading) {
      setSummariesLoading(true);
      let startDate = toStringFormat(filters.startDate)
      let endDate;
      if (filters.endDate)
        endDate = toStringFormat(filters.endDate)
      const Summaries = await getFailedCashplusOperations(startDate, endDate);
      if (!Summaries || Summaries.status == false) {
        alert("Une erreur s'est produite");
        return;
      }
      setData(Summaries);
      setSummariesLoading(false);
    }
  }


  useEffect(async () => {
    reload()
  }, [loading]);

  const handleSearchFilter = (filterType, value) => {
    let newFilter = {
      ...filters,
      [filterType]: value,
    };
    setFilters(newFilter);
  };

  const submitSearch = async () => {
    reload()
  };

  const GenerateCashplusOperationsXlsx = async () => {
    console.dir(filters);
    let startDate = toStringFormat(filters.startDate)
    let endDate = toStringFormat(filters.endDate)
    await DownloadCashplusOperationsXlsx(startDate, endDate);
  };

  if (loading || SummariesLoading) {
    return (
      <div style={{ flex: 1, textAlign: "center" }}>
        <Loader type="TailSpin" color="#00BFFF" height={100} width={100} />
      </div>
    );
  }
  if (!data) {
    console.log("No data");
    return null;
  }
  return (
    <>
        <Row>
          <Col md="12">
            <Card className="card-plain table-plain-bg">
              <Card.Header>
                <Row style={{ float: "left", alignItems: "flex-end" }}>
                  <Col md="2">
                  
                  </Col>
                  <Col md="2">
                  </Col>
                  <Col md="3">
                    <label htmlFor="startDate">Start Date</label>
                    <DatePicker
                      className="form-control"
                      locale="fr"
                      dateFormat="dd/MM/yyyy"
                      selected={filters.startDate}
                      onChange={(date) =>
                        handleSearchFilter("startDate", date)
                      }
                    />
                  </Col>
                  <Col md="3">
                    <label htmlFor="endDate">End Date</label>
                    <DatePicker
                      className="form-control"
                      locale="fr"
                      dateFormat="dd/MM/yyyy"
                      selected={filters.endDate}
                      onChange={(date) => handleSearchFilter("endDate", date)}
                    />
                  </Col>
                  <Col md="1">
                  <Button onClick={submitSearch} variant="primary">Filter</Button>{' '}
                  </Col>
                  <Col md="1">
                  <Button onClick={GenerateCashplusOperationsXlsx} variant="primary">Export</Button>{' '}
                  </Col>
                </Row>
              </Card.Header>
            </Card>
          </Col>
        </Row>
      <CashplusOperationsTable operations={data} refresh={reload}/>
    </>
  );
}

export default CashplusOperations;
